import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  width: 100%;

  display: flex;
  gap: 1rem;
  cursor: pointer;
`
